import { useCallback, useState } from "react";

const useChatMessages = (initialMessages = []) => {
  const [messages, setMessages] = useState(initialMessages);
  const [isTyping, setIsTyping] = useState(false);

  const addMessage = useCallback((message) => {
    const newMessage = {
      id: message.id || Date.now().toString(),
      type: message.type || "user",
      content: message.content,
      timestamp: message.timestamp || new Date(),
      metadata: message.metadata
    };
    setMessages((prev) => [...prev, newMessage]);
    return newMessage;
  }, []);

  const addUserMessage = useCallback(
    (content, metadata) => {
      return addMessage({
        type: "user",
        content,
        metadata
      });
    },
    [addMessage]
  );

  const addSystemMessage = useCallback(
    (content, metadata) => {
      return addMessage({
        type: "system",
        content,
        metadata
      });
    },
    [addMessage]
  );

  const clearMessages = useCallback(() => {
    setMessages([]);
  }, []);

  const resetToWelcome = useCallback((brandName) => {
    setMessages([
      {
        id: Date.now().toString(),
        type: "system",
        content: `Hi! I'm here to help create your next project for ${
          brandName || "your brand"
        }.`,
        timestamp: new Date()
      }
    ]);
  }, []);

  return {
    messages,
    setMessages,
    isTyping,
    setIsTyping,
    addMessage,
    addUserMessage,
    addSystemMessage,
    clearMessages,
    resetToWelcome
  };
};

export default useChatMessages;
